import { matchConfigs } from '../../../../api/app/match'

export default {
  async loadMatchConfigs({ state }) {
    console.log('matchConfigs')
    const { cIds } = state
    const { configMap } = await matchConfigs({ cIds: cIds.join() })
    state.matchConfigs = configMap
    return configMap
  }
}
